let idleTimer: ReturnType<typeof setTimeout>;

// 1 minute (for testing)
//const IDLE_TIMEOUT = 1 * 60 * 1000;

// 10 minutes
//const IDLE_TIMEOUT = 10 * 60 * 1000;

// 15 minutes
const IDLE_TIMEOUT = 15 * 60 * 1000;

// 20 minutes
//const IDLE_TIMEOUT = 20 * 60 * 1000;

const activityEvents = [
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart",
];

export const startAutoLockWatcher = (navigate: any) => {
  console.log(
    `%c[AutoLock] Started — Timeout: ${IDLE_TIMEOUT / 60000} minute(s)`,
    "color: green; font-weight: bold"
  );

  const resetTimer = () => {
    console.log(
      "%c[AutoLock] Activity detected → timer reset",
      "color: #0d6efd"
    );

    clearTimeout(idleTimer);

    idleTimer = setTimeout(() => {
      console.log(
        "%c[AutoLock] 🔒 Idle timeout reached → Locking session",
        "color: red; font-weight: bold"
      );

      localStorage.setItem("isLocked", "true");
      navigate("/lock-screen", { replace: true });
    }, IDLE_TIMEOUT);
  };

  // Attach listeners
  activityEvents.forEach((event) => window.addEventListener(event, resetTimer));

  console.log(
    `%c[AutoLock] Listening to events: ${activityEvents.join(", ")}`,
    "color: gray"
  );

  // Start timer initially
  resetTimer();
};

export const stopAutoLockWatcher = () => {
  console.log("%c[AutoLock] Stopped", "color: orange; font-weight: bold");
  clearTimeout(idleTimer);
};
